<template>
  <FormulateForm v-model="formValues" :errors="errors" ref="form-ref" class="form-section">
    <FormulateInput
      class="form-section__input w-50"
      type="text"
      name="name"
      label="Nama Kolom"
      placeholder="Nama Kolom"
      validation="bail|required:trim|max:30,length"
      validation-behavior="live"
      :help="true"
      :disabled="isLoading"
    />

    <div class="form-section__type">
      <p class="form-section__text">Tipe Kolom</p>
      <p class="form-section__bold-text">{{ typeSelected.title }}</p>
    </div>

    <div class="form-section__checkbox">
      <McCheckbox id="is_required" v-model="formValues.is_required" :disabled="isLoading" />
      <div>
        <label for="is_required" class="form-section__bold-text mb-0">Wajib Diisi</label>
        <p class="form-section__text">
          Centang pilihan ini jika nilai kolom kustom tidak boleh kosong.
        </p>
      </div>
    </div>

    <!-- NOTE: for next development phase -->
    <div v-if="false">
      <p class="form-section__bold-text">Batasan Edit</p>
      <p class="form-section__text">Pilih salah satu Status dimana kustom kolom bisa diedit.</p>
    </div>

    <div v-if="false" class="form-section__status-limit">
      <McCheckbox
        v-for="item in statusItems"
        name="checkbox-status"
        v-model="formValues.editable_status"
        :id="item.key"
        :label="item.label"
        :value="item.key"
        @change="$set(formValues, 'editable_status', [item.key])"
      />
    </div>
  </FormulateForm>
</template>

<script>
import McCheckbox from '@/components/McCheckbox'
import { isEqual } from 'lodash'

import apiErrorMappings from '../../lib/constants/api-error-mappings.js'
import statusItems from '../../lib/constants/status-items.js'

export default {
  components: {
    McCheckbox,
  },
  inject: ['selectedItem'],
  props: {
    typeSelected: {
      type: Object,
      default: () => {
        return {
          key: 'TEXT',
          title: 'Teks',
        }
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    formType: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      statusItems,

      errors: {},
      invalidFormValues: {},

      formValues: {
        name: '',
        type: this.typeSelected.key,
        is_required: false,
        editable_status: [],
      },
      initialFormValues: {},
    }
  },
  computed: {
    hasChanged() {
      return !isEqual(this.formValues, this.initialFormValues)
    },
    invalidFieldKeys() {
      return Object.keys(this.invalidFormValues)
    },
  },
  watch: {
    formValues(newValue) {
      if (this.invalidFieldKeys.length === 0) return

      this.invalidFieldKeys.forEach(key => {
        if (this.invalidFormValues[key] != newValue[key]) {
          // delete the field from the state to show errors
          this.$delete(this.errors, key)
          this.$delete(this.invalidFormValues, key)
        }
      })

      // empty the errorResponse if all error key is deleted
      if (this.invalidFieldKeys.length === 0) {
        this.invalidFormValues = {}
      }
    }
  },
  mounted() {
    if (this.formType != 'update') return

    Object.keys(this.formValues).forEach((key) => {
      this.$set(this.formValues, key, this.selectedItem[key])
    })

    this.initialFormValues = { ...this.formValues }
  },
  methods: {
    handleChangeStatus(key, value) {
      // NOTE: Logic for next enhancement
      // Check all checkboxes if choose 'ALL_TIME'
      // and unchecked all if doesn't

      if (key == 'ALL_TIME') {
        if (value.includes('ALL_TIME')) {
          this.statusItems.forEach((status) => {
            if (!this.formValues.editable_status.includes(status.key)) {
              this.formValues.editable_status.push(status.key)
            }
          })
          return
        }

        this.$set(this.formValues, 'editable_status', [])
        return
      }

      // Check if the status length is statusItems.length - 1
      const almostFullStatusLength =
        this.formValues.editable_status.length == this.statusItems.length - 1

      if (!almostFullStatusLength) return

      const allTimeIndex = this.formValues.editable_status.findIndex(
        (status) => status == 'ALL_TIME'
      )
      // Add 'ALL_TIME' to formValues
      if (allTimeIndex === -1) {
        this.formValues.editable_status.push('ALL_TIME')
        return
      }
      
      // Take out 'ALL_TIME' if one of key is unchecked
      this.formValues.editable_status.splice(allTimeIndex, 1)
    },
    SetErrors(errors) {
      if (Object.keys(errors).length === 0) return
      const fieldErrorKeys = Object.keys(errors)

      fieldErrorKeys.forEach((key) => {
        // Set invalid values to state
        this.$set(this.invalidFormValues, key, this.formValues[key])

        // Set form errors
        this.$set(
          this.errors,
          key,
          apiErrorMappings[key][errors[key]] || 'Terdapat kesalahan format pada input anda'
        )
      })
    },
    GetFormValues() {
      if (this.$refs['form-ref'].hasErrors) {
        this.$mcToast.error('Terdapat kesalahan format pada input anda')
        return false
      }

      let newValues = {}

      if (this.formType == 'create') {
        newValues = { ...this.formValues }
      } else {
        Object.keys(this.formValues).forEach((key) => {
          if (this.formValues[key] == this.initialFormValues[key]) return
  
          newValues[key] = this.formValues[key]
        })
      }

      return newValues
    },
  },
}
</script>

<style lang="scss" scoped>
.form-section {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__input {
    :deep(.formulate-input) {
      padding: 0;
    }
  }

  &__checkbox {
    display: flex;
  }

  &__text {
    color: $mep-color-text-300;
  }

  &__bold-text {
    color: $mep-color-text-400;
    font-weight: 600;
  }

  p {
    margin: 0;
  }

  &__checkbox {
    display: flex;
    gap: 8px;
  }

  &__status-limit {
    display: flex;
    gap: 12px;
  }
}
</style>
